import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// Handles the Emergent Google OAuth redirect: {origin}/#session_id=...
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const nav = useNavigate();
    const loc = useLocation();
    const { refresh } = useAuth();
    const done = useRef(false);
    const [err, setErr] = useState(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        const params = new URLSearchParams((loc.hash || "").replace(/^#/, ""));
        const sid = params.get("session_id");
        if (!sid) { nav("/login", { replace: true }); return; }
        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sid });
                setToken(data.token);
                window.history.replaceState(null, "", window.location.pathname);
                await refresh();
                toast.success(`Welcome, ${data.name}!`);
                nav(data.role === "admin" ? "/admin" : data.role === "professional" ? "/pro" : "/", { replace: true });
            } catch (e) {
                setErr(true);
                toast.error("Google sign-in failed. Please try again.");
                setTimeout(() => nav("/login", { replace: true }), 1500);
            }
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div data-testid="auth-callback" className="flex min-h-screen flex-col items-center justify-center gap-5 bg-white">
            <Logo size={64} showText={false} />
            {!err
                ? <div className="flex items-center gap-2 text-sm font-semibold text-navy/60"><Loader2 className="h-5 w-5 animate-spin" /> Signing you in…</div>
                : <p className="text-sm font-semibold text-red-500">Sign-in failed, redirecting…</p>}
        </div>
    );
}
